import i18n from '@/natives/libs/i18n';
import useMessage from '@/natives/libs/hooks/useMessage';

const getErrorTip = (eCode) => {
  if (i18n.t(eCode) === eCode) {
    return `${i18n.t('error_code')}: ${eCode}`;
  }
  return i18n.t(eCode);
};

let preErrorCode = null;
const handleErrorDoCommon = (err, response) => {
  if (err.errorCode === 'LAP000000') {
    console.error(`[LAP000000]${ response.config.url}`);
  }
  if (preErrorCode === err.errorCode) {
    setTimeout(() => {
      preErrorCode = null;
    }, 60000);
    return;
  }
  preErrorCode = err.errorCode;
  let title = i18n.t('error');
  let type = 'error';
  useMessage({
    title,
    type,
    message: getErrorTip(err.errorCode)
  }).finally(() => {
    // Loading.service().close();
    preErrorCode = null;
  });
};

export default handleErrorDoCommon;
